import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import axios from 'axios';
import './YourData.css';
import HRVAnalysis from './HRVAnalysis';
import ClipLoader from 'react-spinners/ClipLoader';
import CONFIG from '../config.js';

const YourData = () => {
    const { user, fetchData, setFetchData, isAdmin, adminSelectedUser } = useContext(AuthContext);
    let userInfo = user;
    if (isAdmin) {
        userInfo = adminSelectedUser;
    }
    const [loading, setLoading] = useState(true);
    const [maxDate, setMaxDate] = useState('');
    const url = CONFIG.createUrl();

    const config = {headers: CONFIG.HEADERS};

    const fetchMaxDate = async () => {
        try {
            const maxDateResponse = await axios.get(`${url}hrv/predictions/max-day?uuid=${userInfo.uuid}`, config);
            setMaxDate(maxDateResponse.data.max_day);
            setFetchData(prev => ({ ...prev, maxDate: maxDateResponse.data.max_day }));
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!fetchData.maxDate) {
            fetchMaxDate();
        } else {
            setMaxDate(fetchData.maxDate);
            setLoading(false);
        }
    }, []);

    return (
        <>
            {loading &&
                <div className="spinner-container">
                    <ClipLoader color={"#123abc"} loading={loading} size={50} />
                </div>
            }
            {!loading &&
                <HRVAnalysis user={userInfo} maxDate={maxDate} />
            }
        </>
    );
};

export default YourData;
